/*
 * @Author: xuiang 1477388171@QQ.com
 * @Date: 2022-12-27 23:39:25
 * @LastEditors: yanzheng 1477388171@qq.com
 * @LastEditTime: 2023-02-20 18:06:01
 * @FilePath: \wjp_pcqhf_web_vue3\src\router\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import hooks from './hooks'

const routes: RouteRecordRaw[] = [
  {
    path: '/career_statistics',
    component: () => import('@/views/layout/index.vue'),
    redirect: { name: 'systemManagement' },
    name: 'career_statistics',
    children: [
      {
        // 首页
        path: 'homePage',
        component: () => import('@/views/homePage/index.vue'),
        name: 'homePage'
      },
      {
        // 数据填报
        path: 'dataReport',
        component: () => import('@/views/dataReport/index.vue'),
        name: 'dataReport',
        redirect: { name: 'dataList' },
        children: [
          {
            path: 'dataList',
            component: () => import('@/views/dataReport/dataList.vue'),
            name: 'dataList'
          },
          {
            path: 'editForm',
            component: () => import('@/views/dataReport/editForm.vue'),
            name: 'editForm'
          },
          {
            path: 'editFormYdy',
            component: () => import('@/views/dataReport/editFormYdy.vue'),
            name: 'editFormYdy'
          },
          {
            path: 'editFormjly',
            component: () => import('@/views/dataReport/editFormjly.vue'),
            name: 'editFormjly'
          },
          {
            path: 'editTable',
            component: () => import('@/views/dataReport/editTable.vue'),
            name: 'editTable'
          },
          {
            path: 'detailList',
            component: () => import('@/views/dataReport/detailList.vue'),
            name: 'detailList'
          }
        ]
      },
      {
        // 数据审核
        path: 'dataReview',
        component: () => import('@/views/dataReview/index.vue'),
        name: 'dataReview'
      },
      {
        // 数据查询
        path: 'dataQuery',
        component: () => import('@/views/dataQuery/index.vue'),
        name: 'dataQuery',
        redirect: { name: 'dataQueryHome' },
        children: [
          {
            path: 'dataQueryHome',
            component: () => import('@/views/dataQuery/dataQueryHome.vue'),
            name: 'dataQueryHome'
          },
          {
            path: 'dataQueryCreate',
            component: () => import('@/views/dataQuery/dataQueryCreate.vue'),
            name: 'dataQueryCreate'
          },
          {
            path: 'dataQueryCreateSQL',
            component: () => import('@/views/dataQuery/dataQueryCreateSQL.vue'),
            name: 'dataQueryCreateSQL'
          },
          {
            path: 'dataQueryRun',
            component: () => import('@/views/dataQuery/dataQueryRun.vue'),
            name: 'dataQueryRun'
          }
        ]
      },
      {
        // 审核管理
        path: 'reviewManagement',
        component: () => import('@/views/reviewManagement/index.vue'),
        redirect: { name: 'rmDataList' },
        name: 'reviewManagement',
        children: [
          {
            path: 'rmDataList',
            component: () => import('@/views/reviewManagement/rmDataList.vue'),
            name: 'rmDataList'
          },
          {
            path: 'rmReviewList',
            component: () => import('@/views/reviewManagement/rmReviewList.vue'),
            name: 'rmReviewList'
          }
        ]
      },
      {
        // 报送管理
        path: 'dataSummary',
        component: () => import('@/views/dataSummary/index.vue'),
        name: 'dataSummary'
      },
      {
        // 报送管理
        path: 'submitManagement',
        component: () => import('@/views/submitManagement/index.vue'),
        name: 'submitManagement'
      },
      {
        // 系统管理
        path: 'systemManagement',
        component: () => import('@/views/systemManagement/index.vue'),
        name: 'systemManagement',
        redirect: { name: 'account' },
        children: [
          {
            path: 'notice',
            component: () => import('@/views/systemManagement/notice.vue'),
            name: 'notice'
          },
          {
            path: 'account',
            component: () => import('@/views/systemManagement/account.vue'),
            name: 'account'
          },
          {
            path: 'dailyRecord',
            component: () => import('@/views/systemManagement/dailyRecord.vue'),
            name: 'dailyRecord'
          },
          {
            path: 'superAdmin',
            component: () => import('@/views/systemManagement/superAdmin.vue'),
            name: 'superAdmin'
          },
          {
            path: 'helpCenter',
            component: () => import('@/views/systemManagement/helpCenter.vue'),
            name: 'helpCenter'
          }
        ]
      },
      {
        // 报表管理
        path: 'formsManagement',
        component: () => import('@/views/formsManagement/index.vue'),
        name: 'formsManagement'
      },
      {
        // 数据监测
        path: 'dataMonitor',
        component: () => import('@/views/dataMonitor/index.vue'),
        redirect: { name: 'monitorList' },
        name: 'dataMonitor',
        children: [
          {
            path: 'monitorList',
            component: () => import('@/views/dataMonitor/monitorList.vue'),
            name: 'monitorList'
          },
          {
            path: 'monitorForm',
            component: () => import('@/views/dataMonitor/monitorForm.vue'),
            redirect: { name: 'levelStatistics' },
            name: 'monitorForm',
            children: [
              {
                path: 'levelStatistics',
                component: () =>
                  import('@/views/dataMonitor/levelStatistics.vue'),
                name: 'levelStatistics'
              },
              {
                path: 'countStatistics',
                component: () =>
                  import('@/views/dataMonitor/countStatistics.vue'),
                name: 'countStatistics'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
Object.keys(hooks).forEach((hook) => {
  router.beforeEach(hooks[hook])
})
export default router
